import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import { ResourceCollection } from "@/modules/api/resource.collection";

import FactoryRushCapacityProductGroup from "./factory-rush-capacity-product-group.model";

export default class FactoryRushCapacityProductGroupRepository extends BasicRepository<FactoryRushCapacityProductGroup> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<FactoryRushCapacityProductGroup>,
    responseParser: ApiCollectionResponseParserService<FactoryRushCapacityProductGroup>
  ) {
    super(
      "factory_rush_capacity_product_groups",
      api,
      objectBuilder,
      responseParser
    );
  }

  public getAll(
    useCache = true
  ): Promise<ResourceCollection<FactoryRushCapacityProductGroup>> {
    return this.fetchList({}, 1, 9999, undefined, useCache);
  }

  protected prepareData(
    item: FactoryRushCapacityProductGroup
  ): Record<string, string> {
    return {
      name: item.name,
    };
  }
}
